import { render, staticRenderFns } from "./setupHeader.vue?vue&type=template&id=ed4f623c&scoped=true"
import script from "./setupHeader.vue?vue&type=script&lang=js"
export * from "./setupHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4f623c",
  null
  
)

export default component.exports